import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useForm } from '@/common/form/FormContext';
import { EnumSelect } from '@/common/form/formFields/EnumSelect';
import { useMemo } from 'react';

export const ProgPricePriceBasis = ({ fieldDef }) => {

  const { entityFormMode } = useEntityMgr(); 
  const { formValues, assignValue } = useForm(); 

  const updatedFieldDef = useMemo(() => {
    const isFormula = formValues.progPriceCalcType === 'FORMULA';
    if (isFormula) {
      assignValue('priceBasis', null)
    }
    return {
      ...fieldDef,
      disabled: entityFormMode === EntityFormMode.VIEW || isFormula
    }
  }, [formValues.progPriceCalcType]);


  return (
    <EnumSelect fieldDef={updatedFieldDef} />
  ); 
}